export default __webpack_public_path__ + "static/media/andes_a_la_costa_2.3b323357.JPG";